import React, { useState, Fragment, forwardRef } from "react";
import SameForAll from './SameForAll';
import DifferentForEach from './DifferentForEach';
import Select from "antd/es/select/index";

export default forwardRef((props: any, ref: any) => {
  const isSameForAll = props.options[props.language]
                       .every((option)=>option.select===1);
  const defaultComponent = isSameForAll ?
                           <SameForAll {...props} /> :
                           <DifferentForEach {...props} />;
  const [Component, setComponent] = useState(defaultComponent);

  const onChange = (value) => {
    switch (value) {
      case 'SameForAll':
        setComponent(<SameForAll {...props} />);
        break;
      case 'DifferentForEach':
        setComponent(<DifferentForEach {...props} />);
        break;
    }
  }

  return (
    <Fragment>
      <Select defaultValue={isSameForAll ? "SameForAll" : "DifferentForEach"}
              onChange={onChange}
      >
        <Select.Option value="SameForAll">the same answers for all selects</Select.Option>
        <Select.Option value="DifferentForEach">different answers for each select</Select.Option>
      </Select>
      {Component}
    </Fragment>
  );
});